import React from "react";
import { Helmet } from "react-helmet-async";
import InnerBanner from "../components/InnerBanner";
import Faqs from "../components/Faqs";
import serviceBg from "../assets/FFO+.jpeg";
import "./BrandService.css";

const ACService = () => {
  return (
    <>
      <Helmet>
        <title>AC Service and Repair in Bangalore</title>
        <meta
          name="description"
          content="Doorstep AC service and repair in Bangalore for cooling issues, gas leakage, compressor problems, and maintenance."
        />
        <link rel="canonical" href="https://customersupports24x7.in/ac-service-bangalore" />
      </Helmet>

      <div className="brand-service-banner">
        <InnerBanner title="AC Service in Bangalore" bgImage={serviceBg} />
      </div>

      <main className="brand-service-page service-page">
        <p style={{ textAlign: "justify" }}>
          Customer Supports 24x7 provides doorstep AC repair and maintenance in
          Bangalore for cooling, gas leakage, compressor, and electrical issues.
        </p>

        <div className="card">
          <h2>AC Services We Offer</h2>
          <ul style={{ textAlign: "justify" }}>
            <li>AC inspection and fault diagnosis</li>
            <li>Cooling issue and airflow repair</li>
            <li>Gas leakage checks and refilling support</li>
            <li>Compressor and electrical troubleshooting</li>
            <li>Regular AC cleaning and maintenance</li>
          </ul>
        </div>
      </main>

      <Faqs />
    </>
  );
};

export default ACService;
